const STORAGE_KEY = 'tiskstrihu_wishlist';

export function readWishlist(): number[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr.filter((x) => typeof x === 'number') : [];
  } catch { return []; }
}

export function writeWishlist(ids: number[]): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    window.dispatchEvent(new CustomEvent('wishlist-changed', { detail: ids }));
  } catch {}
}

export function isInWishlist(id: number): boolean {
  return readWishlist().includes(id);
}

export function toggleWishlist(id: number): boolean {
  const list = readWishlist();
  const isIn = list.includes(id);
  const next = isIn ? list.filter((x) => x !== id) : [...list, id];
  writeWishlist(next);
  fetch('/api/me')
    .then((r) => r.json())
    .then((me) => {
      if (!me?.data?.logged_in) return;
      if (!isIn) {
        return fetch('/api/wishlist', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id }),
        });
      }
      return fetch(`/api/wishlist?id=${id}`, { method: 'DELETE' });
    })
    .catch(() => {});
  return !isIn;
}
